<template>
	<div class="nav-meta">
		<ul class="nav-meta__list">
			<li class="nav-meta__list-item nav-meta__list-item--login login-widget">
				<WidgetLogin/>
			</li>
			<li
				v-show="showReservation"
				class="nav-meta__list-item nav-meta__list-item--reservation reservation-widget"
			>
				<WidgetReservation/>
			</li>
			<li
				v-show="showCart"
				class="nav-meta__list-item nav-meta__list-item--cart cart-widget"
			>
				<WidgetCart/>
			</li>
		</ul>
	</div>
</template>

<script>
import { mapGetters } from "vuex"
import WidgetLogin from '@/pages/WidgetLogin'
import WidgetCart from '@/pages/WidgetCart'
import WidgetReservation from '@/pages/WidgetReservation'

export default {
	components: {
		WidgetLogin,
		WidgetCart,
		WidgetReservation,
	},
	computed: {
		...mapGetters("location", [
			"locations",
			"locationsLoading",
		]),
		reservationLocations() {
			return this.locations.filter(channel => channel.location.hasReservation && !channel.alternativeBrand)
		},
		showReservation() {
			return this.hasFeature('FEATURE_RESERVATION') && (this.locationsLoading || !!this.reservationLocations?.length)
		},
		showCart() {
			return this.hasFeature('FEATURE_ORDERBOX_DELIVERY') || this.hasFeature('FEATURE_ORDERBOX_TAKEAWAY')
		}
	}
}
</script>

<style>

</style>
